export default __webpack_public_path__ + "static/media/mobile.b97067e4.svg";